import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "react-bootstrap";
 
import iconDropdownDown from '../Assets/icon-dropdown-down.svg'

class HsgToggle extends Component {
    constructor(props) {
        super(props);

        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    render() {
        return (
            <div className="" onClick={this.handleToggleClick} style={{width: this.props.width}}>
                {this.props.children}
            </div>
        );
    }

    handleToggleClick(e) {
        e.preventDefault();
        this.props.onClick(e);
    }
}

class HsgMenu extends Component {
    render() {
        return (
            <div className="dropdown-menu hsg-header-user-menu" onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}

export default class FilterDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMenu: false,
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.onClickMenu = this.onClickMenu.bind(this);
    }

    render() {
        let { dropDownId, label, children, isEnabled } = this.props;

        return (
            <Dropdown id={dropDownId} open={this.state.showMenu} onToggle={this.handleToggle} disabled={!isEnabled}>
                <HsgToggle bsRole="toggle">
                    <div className="hsg-profile-modal-dropdown-group">
                        <div className={`hsg-profile-modal-dropdown-label ${isEnabled ? '' : "hsg-profile-modal-dropdown-disabled"}`}>{label}</div>
                        <img className={`hsg-profile-modal-dropdown-icon ${isEnabled ? '' : "hsg-profile-modal-dropdown-disabled"}`} src={iconDropdownDown}></img>
                    </div>
                </HsgToggle>

                <HsgMenu bsRole="menu" onClick={this.onClickMenu}>
                    {children}
                </HsgMenu>
            </Dropdown>
        );
    }

    handleToggle() {
        const status = !this.state.showMenu;
        this.setState({ showMenu: status });
    }

    onClickMenu() {
        this.setState({ showMenu: false });
    }
}
